import { Texture } from 'three'

export class Assets {
  private texturesMap: Record<string, Texture | null>

  constructor() {
    this.texturesMap = {
      noise: null,
    }
  }

  setTexture({ key, texture }: { key: string; texture: Texture }) {
    this.texturesMap = {
      ...this.textures,
      [key]: texture,
    }
  }

  get textures() {
    return this.texturesMap
  }
}
